import HeroSection from './HeroSection';
import MainPageBody from './MainPageBody';
// import PicturesSection from './PicturesSection';

const HomeRouter = () => {
  return (
    <div>
      <HeroSection />
      <MainPageBody />
      {/* <PicturesSection /> */}
    </div>
  );
};

export default HomeRouter;
